/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PagedModel } from '../model';
/**
 * DeletedRecordsApi - axios parameter creator
 * @export
 */
export const DeletedRecordsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get deleted records count
         * @param {number} [page] 
         * @param {string} [sort] 
         * @param {string} [search] 
         * @param {Array<number>} [et] 
         * @param {boolean} [restorableOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeletedCount: async (page?: number, sort?: string, search?: string, et?: Array<number>, restorableOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/deleted-entities/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (et) {
                localVarQueryParameter['et'] = et;
            }

            if (restorableOnly !== undefined) {
                localVarQueryParameter['restorableOnly'] = restorableOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get deleted records ids
         * @param {number} [page] 
         * @param {string} [sort] 
         * @param {string} [search] 
         * @param {Array<number>} [et] 
         * @param {boolean} [restorableOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeletedRecordIds: async (page?: number, sort?: string, search?: string, et?: Array<number>, restorableOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/deleted-entities/ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (et) {
                localVarQueryParameter['et'] = et;
            }

            if (restorableOnly !== undefined) {
                localVarQueryParameter['restorableOnly'] = restorableOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get deleted records
         * @param {number} [page] 
         * @param {string} [sort] 
         * @param {string} [search] 
         * @param {Array<number>} [et] 
         * @param {boolean} [restorableOnly] 
         * @param {Array<number>} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeletedRecords: async (page?: number, sort?: string, search?: string, et?: Array<number>, restorableOnly?: boolean, id?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/deleted-entities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (et) {
                localVarQueryParameter['et'] = et;
            }

            if (restorableOnly !== undefined) {
                localVarQueryParameter['restorableOnly'] = restorableOnly;
            }

            if (id) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Restore deleted records
         * @param {Array<number>} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreDeletedRecords: async (id?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/deleted-entities/restore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeletedRecordsApi - functional programming interface
 * @export
 */
export const DeletedRecordsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeletedRecordsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get deleted records count
         * @param {number} [page] 
         * @param {string} [sort] 
         * @param {string} [search] 
         * @param {Array<number>} [et] 
         * @param {boolean} [restorableOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeletedCount(page?: number, sort?: string, search?: string, et?: Array<number>, restorableOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeletedCount(page, sort, search, et, restorableOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get deleted records ids
         * @param {number} [page] 
         * @param {string} [sort] 
         * @param {string} [search] 
         * @param {Array<number>} [et] 
         * @param {boolean} [restorableOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeletedRecordIds(page?: number, sort?: string, search?: string, et?: Array<number>, restorableOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeletedRecordIds(page, sort, search, et, restorableOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get deleted records
         * @param {number} [page] 
         * @param {string} [sort] 
         * @param {string} [search] 
         * @param {Array<number>} [et] 
         * @param {boolean} [restorableOnly] 
         * @param {Array<number>} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeletedRecords(page?: number, sort?: string, search?: string, et?: Array<number>, restorableOnly?: boolean, id?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeletedRecords(page, sort, search, et, restorableOnly, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Restore deleted records
         * @param {Array<number>} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreDeletedRecords(id?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreDeletedRecords(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DeletedRecordsApi - factory interface
 * @export
 */
export const DeletedRecordsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeletedRecordsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get deleted records count
         * @param {number} [page] 
         * @param {string} [sort] 
         * @param {string} [search] 
         * @param {Array<number>} [et] 
         * @param {boolean} [restorableOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeletedCount(page?: number, sort?: string, search?: string, et?: Array<number>, restorableOnly?: boolean, options?: any): AxiosPromise<number> {
            return localVarFp.getDeletedCount(page, sort, search, et, restorableOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get deleted records ids
         * @param {number} [page] 
         * @param {string} [sort] 
         * @param {string} [search] 
         * @param {Array<number>} [et] 
         * @param {boolean} [restorableOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeletedRecordIds(page?: number, sort?: string, search?: string, et?: Array<number>, restorableOnly?: boolean, options?: any): AxiosPromise<Array<number>> {
            return localVarFp.getDeletedRecordIds(page, sort, search, et, restorableOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get deleted records
         * @param {number} [page] 
         * @param {string} [sort] 
         * @param {string} [search] 
         * @param {Array<number>} [et] 
         * @param {boolean} [restorableOnly] 
         * @param {Array<number>} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeletedRecords(page?: number, sort?: string, search?: string, et?: Array<number>, restorableOnly?: boolean, id?: Array<number>, options?: any): AxiosPromise<PagedModel> {
            return localVarFp.getDeletedRecords(page, sort, search, et, restorableOnly, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Restore deleted records
         * @param {Array<number>} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreDeletedRecords(id?: Array<number>, options?: any): AxiosPromise<Array<number>> {
            return localVarFp.restoreDeletedRecords(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeletedRecordsApi - object-oriented interface
 * @export
 * @class DeletedRecordsApi
 * @extends {BaseAPI}
 */
export class DeletedRecordsApi extends BaseAPI {
    /**
     * 
     * @summary Get deleted records count
     * @param {number} [page] 
     * @param {string} [sort] 
     * @param {string} [search] 
     * @param {Array<number>} [et] 
     * @param {boolean} [restorableOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeletedRecordsApi
     */
    public getDeletedCount(page?: number, sort?: string, search?: string, et?: Array<number>, restorableOnly?: boolean, options?: any) {
        return DeletedRecordsApiFp(this.configuration).getDeletedCount(page, sort, search, et, restorableOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get deleted records ids
     * @param {number} [page] 
     * @param {string} [sort] 
     * @param {string} [search] 
     * @param {Array<number>} [et] 
     * @param {boolean} [restorableOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeletedRecordsApi
     */
    public getDeletedRecordIds(page?: number, sort?: string, search?: string, et?: Array<number>, restorableOnly?: boolean, options?: any) {
        return DeletedRecordsApiFp(this.configuration).getDeletedRecordIds(page, sort, search, et, restorableOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get deleted records
     * @param {number} [page] 
     * @param {string} [sort] 
     * @param {string} [search] 
     * @param {Array<number>} [et] 
     * @param {boolean} [restorableOnly] 
     * @param {Array<number>} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeletedRecordsApi
     */
    public getDeletedRecords(page?: number, sort?: string, search?: string, et?: Array<number>, restorableOnly?: boolean, id?: Array<number>, options?: any) {
        return DeletedRecordsApiFp(this.configuration).getDeletedRecords(page, sort, search, et, restorableOnly, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Restore deleted records
     * @param {Array<number>} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeletedRecordsApi
     */
    public restoreDeletedRecords(id?: Array<number>, options?: any) {
        return DeletedRecordsApiFp(this.configuration).restoreDeletedRecords(id, options).then((request) => request(this.axios, this.basePath));
    }
}
